export default __webpack_public_path__ + "a66a02a6dbf32da917a86f2bb8845a05.png";